import classNames from 'classnames'
import includes from 'lodash/includes'
import { useTranslation } from 'react-i18next'

export const BookingStatusBadge = ({ status, isOfficeBlock }) => {
  const { t } = useTranslation()
  return (
    <span
      className={classNames(`text-xs font-medium p-1 rounded-md inline-block text-center min-w-[80px]`, {
        'bg-gray-200 text-black': status === 'pending',
        'bg-rose-400 !text-white': status === 'cancelled' || status === 'rejected' || status === 'failedPayment',
        'bg-green-500 !text-white': status === 'completed' || status === 'confirmed',
        'bg-blue-300 text-black': !includes(['pending', 'cancelled', 'rejected', 'failedPayment', 'completed', 'confirmed'], status),
      })}
    >
      {isOfficeBlock ? t('bookings.status.officeBlock') : t(`bookings.status.${status}`)}
    </span>
  )
}

export const PaymentStatusBadge = ({ status }) => {
  const { t } = useTranslation()
  return (
    <span
      className={`text-xs font-regular ${
        status === 'paid' ? 'bg-green-100 text-green-700' : status === 'failure' ? 'bg-red-100 text-red-700' : status === 'unpaid' ? 'bg-yellow-100 text-yellow-800' : 'bg-gray-200'
      } px-2 py-1 rounded-md`}
    >
      {t(`bookings.paymentStatus.${status}`)}
    </span>
  )
}
